// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_dn-j";
export var fulfillmentFormRail = "_dn-i";
export var headerTitleRow = "_dn-l";
export var orderDetailsWrapper = "_dn-g";
export var orderLinkTrigger = "_dn-2";
export var paymentInformationGrid = "_dn-q";
export var paymentSummaryColumn = "_dn-r";
export var phoneShipmentPickerButton = "_dn-e";
export var phoneShipmentPickerButtonContent = "_dn-f";
export var phoneShipmentPickerButtonWrapper = "_dn-d";
export var phoneShipmentPickerTrigger = "_dn-c";
export var shipmentContainer = "_dn-k";
export var shipmentDetailsMainPane = "_dn-h";
export var shipmentNavigationCard = "_dn-a";
export var shipmentNavigationEdgeTrigger = "_dn-6";
export var shipmentNavigationRail = "_dn-3";
export var shipmentNavigationRailEnter = "_dn-5";
export var shipmentNavigationRailHeader = "_dn-9";
export var shipmentNavigationRailOverlay = "_dn-4";
export var shipmentNavigationScrim = "_dn-7";
export var shipmentSummaryFact = "_dn-n";
export var shipmentSummaryGrid = "_dn-m";
export var shipmentSummaryMetadataRow = "_dn-o";
export var shipmentSummaryTags = "_dn-p";
export var shipmentWorkspace = "_dn-0";
export var shipmentWorkspaceBodyTablet = "_dn-8";
export var shipmentWorkspaceContent = "_dn-b";
export var shipmentWorkspaceHeader = "_dn-1";